export default "__VITE_ASSET__BWRvuXeR__"